module.exports = __webpack_public_path__ + "static/media/activeFilter.aca2feb3.svg";